let config = {
    baseURL: process.env.VUE_APP_ROOT_API,
}


export default config;